import { AutogenModelSettlementPayee, AutogenRowSettlementPayee } from "./autogen/AutogenModelSettlementPayee";

export class ModelSettlementPayee extends AutogenModelSettlementPayee<RowSettlementPayee> {
	constructor() {
		super(RowSettlementPayee);
	}
}

export class RowSettlementPayee extends AutogenRowSettlementPayee {
}